import { store } from '@remote/store'
import { USER_DOWNLOAD_URL } from '@remote/constant'

export const useDownload = (callback?:Function) => {
  const mapIds = new Map()

  const downloadList = (list, downloadPath?:string, taskName?:string) => {
    console.log('downloadList', list, downloadPath)
    callback && callback()
    const indexs:{ size: number; index: number }[] = []
    const ids:string[] = []
    let params: any = {}
    for (const item of list) {
      const id = item.id.split('.')[0]
      if (!mapIds.has(id)) {
        mapIds.set(id, [])
      }
      console.log('downloadList 1', JSON.stringify(item), item.file.file_index);
      (mapIds.get(id) as [string]).push(item)
      indexs.push(({ size: +item.file_size, index: item.file_index !== void 0 ? item.file_index : item.file.file_index }))
      ids.push(item.file_index)
      params = {
        file: {
          id: item.id,
          name: taskName || item.name,
          size: item.file_size,
          url: item.meta.url,
          file_count: item.file_count,
          file_extension: (item.meta.mime_type || '').split('/').pop(),
          ids,
          index: item.file_index || item.file.file_index,
          indexs,
        },
        type: USER_DOWNLOAD_URL,
        downloadPath,
      }
    }
    store.dispatch('download', params)
    store.dispatch('getTasks', { getAll: true })
  }

  return {
    downloadList,
  }
}